export default {
    message: {
        'header': {
            'online': '在线人数'
        },
        'footer': {
            'home': '主页',
            'points': '积分',
            'vip_zone': 'VIP区',
            'order': '订单',
            'account': '我的'
        },
        'index': {
            'notice1': "祝贺选手",
            'notice2': "的参与，赢得",
            'notice3': "让我们祝贺他！",
            'hot_spot': '热卖',
            'all_goods': '全部商品',
            'promotion_type': '促销类型',
            'partners': '合作伙伴',
            'announcement': '公告',
            'cancel': '取消',
            'travel_to': '前往',
            'ok': '确定'
        },
        'goods': {
            'name1': '双倍返回',
            'name2': '双倍现金返还',
            'name3': '70 倍退款(VIP1)',
            'name4': '现金72倍返回'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'banner2': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'banner3': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'banner4': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_50': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_5': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_150': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_25': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_500': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/1.jpg',
            'goods_img_return': 'https://zhouyaoming.in2015.com/uploads/lang_img/cn/2.jpg'
        },
        'detail': {
            'please_select': '请选择',
            'product_description': '商品详情',
            'check_out': '选择',
            'original_price': '原价',
            'inventory': '库存',
            'sold': '销量',
            'tip_start': '促销成功可以免费获得',
            'tip_end': ' ₫',
            'quantity': '数量',
            'total_price': '总价',
            'win_rate': '获胜率',
            'predict_type': '预测类型',
            'member_shared': '分享购买成功将会获得',
            'share_now': '现在去分享',
            'copy_the_link': '复制链接',
            'send_to_friend': '发送给朋友',
            'copy_success': '复制成功',
            'copy_error': '复制失败'
        },
        'integral': {
            'title': '积分兑换区',
            'search': '输入商品信息',
            'points': '积分'
        },
        'vip_zone': {
            'title': 'VIP商品列表',
            'price': '价格',
            'sales_volume': '销量'
        },
        'login': {
            'account_login': ['账号登录'],
            'login': '登录',
            'phone': '输入手机号',
            'pwd': '填写密码',
            'no_account': '还没有账号?',
            'forgot_password': '忘记密码',
            'register': '注册'
        },
        'reset_pwd': {
            'title': '重置密码',
            'get_verification_code': '获取验证码',
            'confirm': '确认',
            'verification_code': '验证码',
            'your_new_pwd': '新密码',
            'reload': '重发',
            'msg_phone': '请填写你的手机号'
        },
        'register': {
            'register_account': '注册',
            'account': '填写电话号码',
            'pwd': '登录密码',
            'con_pwd': '密码',
            'register': '注册',
            'tip_account': '已有账号?',
            'by_click': '点击"注册"，同意使用 Interesting mall',
            'privacy_policy': '隐私政策',
            'tip_wrong': '*错误的手机号码将无法正常使用网站。',
            'msg_phone': '电话号码格式错误'
        },
        'order': {
            'submit_order': '提交订单',
            'item': '项',
            'payment_method': '付款方式',
            'pay_via_balance': '余额',
            'balance_available': '可用余额',
            'total_price': '总价',
            'total': '总价',
            'check_out': '提交',
            'msg_param': '参数错误',
            'msg_order_field': '订单数据加载失败',
            'msg_select_payment': '请选择付款方式',
            'tip_create_order': '订单创建中...',
            'payment_succeeded': '付款成功',
            'payment_fail': '付款失败',
            'order_no': '订单号',
            'order_time': '下单时间',
            'other': '其它',
            'total_amount': '总金额',
            'failure_reason': '失败原因',
            'view_payment_results': '查看付款结果',
            'payment_failed_to_repay': '付款失败未响应',
            'top_up': '充值',
            'hot_spot': '热卖',
            'back_home': '返回首页',
            'msg_create_success': '订单创建成功',
            'confirm_title': '支付',
            'confirm_msg': '付款失败,',
            'confirm_cancel': '取消',
            'confirm_top_up': '去充值',
            'game_odd': '奇',
            'game_even': '偶',
            'game_title': '奇偶',
            'game_select_title': '选择预测结果',
            'game_odd_number': '奇数',
            'game_even_number': '偶数',
            'game_confirm_selection': '确认选择',
            'game_opening_time': '开始时间',
            'game_issue': '期号',
            'game_number': '数字',
            'game_results': '结果',
            'game_submit_err': '错误:订单号不存在!',
            'game_choose_least': '至少选择一个!',
            'game_success': '成功',
            'game_error': '错误',
            'game_confirm': '确认',
            'game_confirm_title': '消息',
            'game_confirm_msg': '确定选择这个吗?',
            'game_confirm_cancel': '取消',
            'chart': '图表',
            'close': '关闭',
            'bulls_eye': '数字统计',
            'trend_recent': '近50期的走势',
            'number': '数字',
            'times_without': '次',
            'bet': 'bet'
        },
        'my_order': {
            'title': '我的订单',
            'operated': '全部',
            'receive': '已收货',
            'completed': '处理中',
            'converted': '获得积分',
            'refund': '促销成功',
            'item_total_amount': '项，总金额',
            'picking_up': '退货',
            'redeem_points': '获得积分',
            'processing_pick_up': '退货过程',
            'hot_spot': '热卖',
            'view_details': '详情',
            'check_tracking': '检查信息',
            'confirm_receival': '确认收货',
            'receipt': '收据',
            'cancel': '取消',
            'confirm_pick_up': '确认退货',
            'not_sales': '没有促销',
            'sales_failed': '促销失败',
            'sales_success': '促销成功',
            'waiting_draw': '等待促销',
            'bonus_countdown': '促销倒计时',
            'redeem_success': '积分成功',
            'awarded': '中奖',
            'points': '积分',
            'fee': '手续费',
            'cash': '现金',
            'sure': '确定',
            'detail_title': '订单详情',
            'detail_copy': '复制',
            'detail_order_no': '订单号',
            'detail_order_time': '订单时间',
            'detail_type_order': '订单类型',
            'detail_status_payment': '支付状态',
            'detail_have_pay': '已支付',
            'detail_did_pay': '未支付',
            'detail_promotion_status': '促销状态',
            'detail_promotion_period': '期号',
            'detail_promotion_games': '促销类型',
            'detail_opening_time': '开始时间',
            'detail_my_choice': '我的猜测',
            'detail_lottery_numbers': '数字',
            'detail_payment_method': '支付类型',
            'detail_total_amount': '总金额',
            'detail_amount_paid': '总支付',
            'detail_re_order': '再次下单'
        },
        'user': {
            'account': '我的账号',
            'available_balance': '可用余额',
            'my_points': '我的积分',
            'active_code': '活动码',
            'your_code': '输入活动码',
            'msg_code': '请填写活动码',
            'ok': '确定',
            'deposit': '充值',
            'withdraw': '提现',
            'confirm_title': '确认修改?',
            'confirm_msg': '头像修改',
            'confirm_cancel': '取消',
            'confirm_ok': '确认',
            'cancelled': '取消成功',
            'profile_title': '用户简介',
            'profile_manage_account': '管理我的账号',
            'profile_nickname': '昵称',
            'profile_real_name': '真实姓名',
            'profile_email': '邮件',
            'profile_phone': '电话',
            'profile_password': '密码',
            'profile_click_change_password': '点击修改密码',
            'profile_save_the_change': '保存',
            'profile_log_out': '退出',
            'profile_confirm_title': '退出',
            'profile_confirm_msg': '确认退出?',
            'profile_confirm_cancel': '取消',
            'profile_confirm': '确定',
            'change_password_title': '修改密码',
            'change_password_current_pwd': '输入当前密码',
            'change_password_set_new_pwd': '设置新密码',
            'change_password_confirm_new_pwd': '确认新密码',
            'change_password_confirm_change': '确认修改',
            'change_password_msg_current_pwd': '请填写当前密码',
            'change_password_msg_new_pwd': '请填写新密码',
            'change_password_msg_new_pwd_again': '请填写确认密码',
            'change_password_msg_not_match': '密码不匹配',
            'user_rank_title': '促销记录',
            'user_menu_bulletin': '简报',
            'user_menu_vip': '会员',
            'user_menu_binance_pay': '币安支付',
            'user_menu_agent': '代理',
            'user_menu_balance_details': '余额',
            'user_menu_lottery_record': '促销记录',
            'user_menu_service': '服务',
            'user_menu_about_us': '关于我们'
        },
        'balance_detail': {
            'title': '余额详情',
            'total_amount': '总金额',
            'top_up': '充值',
            'accumulated_withdrawal': '累计提现',
            'bill_record': '账单记录',
            'consumption_records': '消费记录',
            'recharge_records': '充值记录',
            'points_center': '积分中心',
            'sign_in': '签到获取积分',
            'upgrade_level': '升级等级以解锁更多游戏！'
        },
        'my_pay': {
            'title': '电子钱包',
            'phone': '电话',
            'phone_plac': '输入电话',
            'binance_id': '币安id',
            'binance_id_plac': '输入币安id',
            'pay_nickname': '支付昵称',
            'pay_id': '支付id',
            'pay_id_plac': '输入支付id',
            'tip': '请确保所有信息正确无误，否则您将无法取款。',
            'bind': '绑定',
            'edit': '修改',
            'msg_nickname': '请填写支付昵称',
            'confirm_msg': "<b style='color: red'>注意</b>: 支付昵称只能修改一次 ! ! !<br>支付昵称:",
            'confirm_title': '币安支付昵称修改',
            'confirm_cancel': '取消',
            'confirm_cancelled': '取消成功',
            'confirm_confirm': '确认',
            'msg_phone': '请填写手机号码',
            'msg_binance_id': '请填写币安ID',
            'msg_binance_id_format': '币安ID格式错误',
            'msg_pay_nickname': '请填写币安支付昵称',
            'msg_pay_id': '请填写币安支付ID',
            'msg_pay_id_format': '币安支付ID格式错误',
            'msg_pay_id_length': '币安支付ID长度错误',
            'msg_binance_pay': '币安ID不是币安支付ID,币安支付ID可以在币安钱包页面找到',
            'msg_confirm_title': '币安支付信息确认',
            'msg_confirm_msg1': '币安昵称',
            'msg_confirm_msg2': '币安支付id',
            'msg_confirm_msg3': '注意：一旦确认，就不能解除绑定！',
            'msg_confirm_cancel': '取消',
            'msg_confirm_cancelled': '取消成功',
            'msg_confirm': '确认',
            'bind_success_msg': '绑定成功，获得',
            'select_bank_name': '选择银行',
            'bank_name': '银行名',
            'bank_account': '银行账户',
            'beneficiary_name': '持卡人姓名',
            'msg_bank_account': '请填写银行卡账户',
            'msg_beneficiary_name': '请填写持卡人姓名',
            'msg_confirm_msg4': '持卡人',
            'msg_confirm_msg5': '银行账户',
        },
        'user_bill': {
            'title': '账单详情',
            'all': '全部',
            'consumption': '消费',
            'recharge': '充值',
            'income': '收入'
        },
        'user_integral': {
            'title': '积分详情',
            'current_points': '当前积分',
            'accumulated_points': '累计积分',
            'accumulated_consumption': '消费积分',
            'obtained_today': '今日获得',
            'details_points': '积分详情',
            'increase_points': '加积分',
            'points_rewarded_purchasing': '购买商品获得积分',
            'earn_points': '赚取积分',
            'points_rewarded_sign': '每日签到获得积分',
            'sign_points': '积分',
            'sign_details': '详情',
            'sign_signed': '已签到',
            'sign_sign': '签到',
            'sign_accumulated_sign': '累计签到',
            'sign_days': '天',
            'sign_tip2_s': '如果连续签到',
            'sign_tip2_e': '天,可以获得更多的积分哟~~~',
            'sign_click_load_more': '点击加载更多',
            'sign_success': '签到成功',
            'sign_awarded': '获得积分',
            'sign_sure': '确定',
            'sign_cnum': ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            'sign_msg_signed': '您今天已签到!',
            'detail_title': '积分订单',
            'detail_phone': '电话',
            'detail_payment_method': '付款方式',
            'detail_pay_with_points': '积分支付',
            'detail_available_points': '可用积分',
            'detail_total': '总计',
            'detail_points': '积分',
            'detail_check_out': '确认',
            'pay_points': '积分支付',
            'detail_parameter_wrong': '参数错误',
            'detail_failed_data': '数据加载失败',
            'detail_creating_order': '订单创建中...',
            'detail_creating_order_fail': '订单创建失败',
            'detail_status_title': '积分兑换成功',
            'detail_status_check_mailbox': '注意查收，我们将24小时内发货',
            'detail_status_view_order': '查看订单详情',
            'detail_status_back_home': '返回主页',
            'detail_points_title': '积分详情',
            'my_order_points_title': '我的积分订单'
        },
        'recharge': {
            'title': '充值申请提交',
            'first_deposit': '首充福利，赠送',
            'use_binance': '选择币安',
            'choose_amount': '请选择充值金额',
            'current_balance': '注:当前余额',
            'confirm_top_up': '确认充值',
            'application_details': '充值申请详情',
            'order_number': '单号',
            'application_time': '申请时间',
            'top_up_amount': '充值金额',
            'top_up_status': '充值状态',
            'reviewing': '审核中',
            'application_success': '充值成功',
            'application_failed': '充值失败',
            'msg_bind_binance': '请绑定币安支付',
            'msg_minimum_bank': '最小充值金额100',
            'msg_minimum_binance': '最小充值金额1',
            'msg_enter_top_up_amount': '请输入充值金额',
            'confirm_title': '充值详情',
            'confirm_verify_information': '请确认充值信息',
            'confirm_tip': '使用绑定的Binance Pay向我们帐户付款，单击右上角查看教程。',
            'confirm_our_pay_id': '我们的支付ID',
            'confirm_copy': '复制',
            'confirm_top_up_amount': '充值金额',
            'confirm_confirm_top_up': '确认充值',
            'confirm_msg_copy': '复制成功',
            'confirm_msg_enter_amount': '请输入金额',
            'confirm_transfer_amount': '充值金额至少是1',
            'confirm_alert_mes': '请确认绑定Binance pay已向我们成功支付<b style=\'color: red\'> 到账时间请等待5-10分钟 </b>如果您有任何疑问，请及时联系客服',
            'confirm_alert_title': '提交充值申请',
            'confirm_alert_cancel': '取消',
            'confirm_alert_msg_cancelled': '取消成功',
            'confirm_alert_confirm': '确认'
        },
        'withdrawal': {
            'title': '提现',
            'link_now_tip': '你尚未绑定电子钱包，绑定成功后再次申请提现',
            'link_now': '现在去绑定',
            'withdrawal_account': '提现账号',
            'phone': '电话',
            'binance_id': '币安ID',
            'nickname': '昵称',
            'pay_id': '支付ID',
            'withdraw_amount': '提现金额',
            'balance': '余额',
            'processing_fee': '手续费',
            'actual_amount': '实际金额',
            'msg_withdrawal_account': '请选择提现账号',
            'msg_fill_data': '请填写数据',
            'msg_phone': '请填写手机号',
            'msg_binance_id': '请填写币安ID',
            'msg_binance_pay_id': '请填写币安支付ID',
            'msg_pay_id_err': '支付ID格式错误',
            'msg_withdraw_amount': '请填写提现金额',
            'msg_insufficient_balance': '余额不足',
            'msg_mini_withdraw': '最小提现金额160',
            'msg_minimum': '最小',
            'msg_to_withdraw': '提现',
            'audit_tip': '提现已提交，审核中',
            'audit_sure': '确定'
        },
        'user_vip': {
            'vip': '会员',
            'title': '会员中心',
            'able_purchase': '购买商品在',
            'off': '折',
            'level_task1': '完成 1USDT 充值和50次商品购买',
            'level_task2': '提现费用',
            'level_task3': '提现时间',
            'level_task4': '小时',
            'vip_level_unlocked': '会员级别解锁',
            'higher_level_unlocked': '高级解锁',
            'vip_upgrade_requirements': '会员升级要求',
            'required_tasks': '必须完成的任务',
            'select_one_below': '请选择以下选项',
            'achieved': '已完成',
            'conditions_met': '未完成',
            'accumulated_participation': '累计完成促销',
            'achieved_top_up': '累计充值 50 ₫',
            'exclusive_coupons': '独享优惠券',
            'more_games': '次促销',
            'need_recharge': '必须充值 50 ₫'
        },
        'promoter': {
            'title': '代理人管理',
            'apply_agency': '申请成为我们的代理',
            'become_agent': '代理',
            'repeatedly_delayed': '上传可能会延迟，请稍候，不要重复点击',
            'current_commission': '当前佣金',
            'record': '记录',
            'profit_yesterday': '昨日获利',
            'accumulated_withdrawal': '累计提现',
            'withdraw': '提现',
            'refer_friends': '分享',
            'total_agent': '代理统计',
            'copy_success': '复制成功',
            'copy_error': '复制失败',
            'promoter_achievements': '推广业绩',
            'promoter_orders': '代理订单',
            'promoter_ranking': '代理排名',
            'commission_ranking': '佣金排名',
            'list_title': '代理人人数',
            'list_number_agents': '代理人人数',
            'list_people': '人',
            'list_date_joined': '申请日期',
            'list_item': '项',
            'order_title': '累计订单数',
            'order_accumulated_orders': '累计订单数',
            'order_commission': '佣金',
            'order_time': '订单时间',
            'order_mark': '备注',
            'commission_title': '推广业绩',
            'commission_accumulated_commission': '累计佣金',
            'commission_available': '累计佣金提现',
            'commission_week': '本周新增人数',
            'commission_month': '本月新增人数',
            'commission_achievement': '累计金额',
            'commission_rank_title': '佣金排名',
            'commission_rank_current': '当前排名',
            'commission_rank_yet': '你还没有排名',
            'rank_title': '推广排名',
            'cash_record_title': '佣金提现详情',
            'cash_record_cash_out': '提现记录',
            'user_cash_title': '佣金提现',
            'user_cash_not_link': '您还没绑定电子钱包，请先去绑定并',
            'user_cash_link_now': '现在去',
            'user_cash_service_provider': '电子钱包',
            'user_cash_select_account': '请选择账号',
            'user_cash_binance_pay': '币安支付',
            'user_cash_bank_account': '银行账号',
            'user_cash_bank_account_pla': '请填写银行账号',
            'user_cash_ifsc_pla': '请填写ifsc',
            'user_cash_upi_pla': '请填写upi',
            'user_cash_withdraw': '提现',
            'user_cash_minimum': '最小',
            'user_cash_to_withdraw': '才能提现',
            'user_cash_current_commission': '当前累计佣金',
            'user_cash_account': '账号',
            'user_cash_account_pla': '请填写你的账号',
            'user_cash_current_withdrawal': '当前佣金提现',
            'user_cash_to_e_wallet': '提现到钱包',
            'user_cash_to_balance': '提现到余额',
            'user_cash_insufficient_balance': '余额不足',
            'user_cash_data_format': '数据格式错误'
        },
        'service': {
            'title': '消息记录',
            'write_email': '请给我们发电子邮件'
        }
    }
};